// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallOutgoing24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.14161 7.09766C8.64435 7.09766 8.24124 7.50076 8.24124 7.99802C8.24124 8.49528 8.64435 8.89839 9.14161 8.89839H13.8279L7.36161 15.3646C7.01 15.7162 7.01 16.2863 7.36161 16.6379C7.71323 16.9896 8.28331 16.9896 8.63492 16.6379L15.1012 10.1717L15.1012 14.858C15.1012 15.3552 15.5043 15.7583 16.0015 15.7583C16.4988 15.7583 16.9019 15.3552 16.9019 14.858V7.99802C16.9019 7.87011 16.8752 7.74843 16.8272 7.63823C16.7883 7.54908 16.7344 7.46492 16.6653 7.38967C16.6483 7.37112 16.6305 7.35328 16.612 7.33621C16.5341 7.26424 16.4466 7.20856 16.3538 7.16916C16.2456 7.12313 16.1265 7.09766 16.0015 7.09766H16.0015L9.14161 7.09766Z"
				/>
			</Svg>
		);
	}
);
SvgCallOutgoing24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallOutgoing24;
